import { render, staticRenderFns } from "./CertificateList.vue?vue&type=template&id=f00d2b50&scoped=true&"
import script from "./CertificateList.vue?vue&type=script&lang=js&"
export * from "./CertificateList.vue?vue&type=script&lang=js&"
import style0 from "./CertificateList.vue?vue&type=style&index=0&id=f00d2b50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f00d2b50",
  null
  
)

export default component.exports